import FundraiserJoinPage from '@/pages/fundraisers/public/FundraiserJoinPage.vue'
import FundraiserPublicPage from '@/pages/fundraisers/public/FundraiserPublicPage.vue'
import FundraiserDonatePage from '@/pages/fundraisers/public/FundraiserDonatePage.vue'
import FundraiserDonationReturnPublicPage from '@/pages/fundraisers/public/donation-return/FundraiserDonationReturnPublicPage.vue'
import FundraiserInviteAcceptPagePublic from '@/pages/fundraiser-invites/public/FundraiserInviteAcceptPagePublic.vue'
import FundraiserRedirectOldPage from '@/pages/fundraisers/public/FundraiserRedirectOldPage.vue'
import TeamPublicPage from '@/pages/fundraisers/public/TeamPublicPage.vue'
export default [
  {
    path: "/campaigns/:fundraiserId/:slug/widget",
    name: 'FundraiserPublicWidgetPage',
    component: FundraiserPublicPage,
    props: route => ({ fundraiserId: parseInt(route.params.fundraiserId), slug: route.params.slug, section: route.params.section, layout: 'fundraiser-layout-widget' }),
  },
  {
    path: "/campaigns/:fundraiserId/:slug/:section?",
    name: 'FundraiserPublicPage',
    component: FundraiserPublicPage,
    props: route => ({ fundraiserId: parseInt(route.params.fundraiserId), slug: route.params.slug, section: route.params.section }),
  },

  {
    path: "/campaigns/:fundraiserId/join",
    name: 'FundraiserPublicJoinPage',
    component: FundraiserJoinPage,
    props: route => ({ fundraiserId: parseInt(route.params.fundraiserId)})
  },
  {
    path: "/campaigns/:fundraiserId/donations/:donationId/return",
    name: 'FundraiserDonationReturnPublicPage',
    component: FundraiserDonationReturnPublicPage,
    props: route => ({ fundraiserId: parseInt(route.params.fundraiserId), donationId: parseInt(route.params.donationId)})
  },
  {
    path: "/campaigns/:fundraiserId/donate",
    name: 'FundraiserDonatePage',
    component: FundraiserDonatePage,
    props: route => ({ fundraiserId: parseInt(route.params.fundraiserId)})
  },

  {
    path: "/fundraiser-invites/:uuid/accept",
    name: 'FundraiserInviteAcceptPagePublic',
    component: FundraiserInviteAcceptPagePublic,
    props: route => ({ fundraiserInviteUuid: route.params.uuid })
  },
  {
    path: "/fundraiser-redirect/:oldId",
    name: 'FundraiserRedirectOld',
    component: FundraiserRedirectOldPage,
    props: route => ({ oldId: parseInt(route.params.oldId) })
  }
]
